import DonatePage from "./container";

export default DonatePage;